import { signInSuccess } from './containers/Authorization/actions';
import configureRedux from './configureRedux';

export default (jwtToken, callback) => {
  configureRedux({}, (store) => {
    store.dispatch(signInSuccess(jwtToken));
    callback(store);
  });
};
